import _IconButton from "@material-ui/core/esm/IconButton";
import React from 'react';
import classnames from 'classnames';
import ConfigurableLink from 'swag-client-common/components/utils/configurable-link';
import FavoriteIcon from 'swag-client-common/components/ui/favourite-icon';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import BadgeNumber from '../badge-number';
import classes from './favourites-link.scss';
export const FavouritesLink = function FavouritesLink({
  className = undefined,
  isHardLink,
  activeClassName = undefined,
  routeNavigationConfirmation = undefined,
  itemsNumber = 0,
  isLoggedIn,
  onClick,
  isLoading
}) {
  const [isSelected, setIsSelected] = React.useState(false);
  let timeout = null;
  React.useEffect(() => {
    if (isLoading) {
      // @todo. auto generated. fix this error
      // @ts-ignore
      clearTimeout(timeout);
      setIsSelected(true);
    } else {
      // @todo. auto generated. fix this error
      // @ts-ignore
      timeout = setTimeout(() => setIsSelected(false), 2500);
    }
  }, [isLoading]);
  return /*#__PURE__*/React.createElement(ConfigurableLink, {
    link: APP_ROUTES.FAVORITE_PRODUCTS,
    onClick: onClick,
    className: classnames(className, classes.row, {
      [classes.emptyCircle]: itemsNumber === 0 && !isLoggedIn
    }),
    activeClassName: activeClassName,
    isHardLink: isHardLink,
    routeNavigationConfirmation: routeNavigationConfirmation
  }, /*#__PURE__*/React.createElement(_IconButton, {
    disableRipple: true,
    className: classes.cartButton,
    size: "small",
    "aria-label": "cart"
  }, /*#__PURE__*/React.createElement(BadgeNumber, {
    badgeClassName: classes.badge,
    isLoading: isLoading,
    isLoggedIn: isLoggedIn,
    itemsNumber: itemsNumber,
    spinnerClassName: classes.spinner,
    iconComponent: /*#__PURE__*/React.createElement(FavoriteIcon, {
      isSelected: isSelected
    })
  })));
};